import type { LeadStage } from '@/lib/types/lead';

export const LEAD_CAMPAIGN_SOURCE_CONTACT = 'contact';
export const LEAD_CAMPAIGN_MEDIUM_CONTACT = 'contact-form';

export const LEAD_STAGE_OPTIONS: Array<{ value: LeadStage; label: string }> = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'tour_scheduled', label: 'Tour scheduled' },
  { value: 'application_submitted', label: 'Application submitted' },
  { value: 'lease_negotiation', label: 'Lease negotiation' },
  { value: 'converted', label: 'Converted' },
  { value: 'lost', label: 'Lost' },
];

const LEAD_STAGE_LABEL_MAP: Record<LeadStage, string> = LEAD_STAGE_OPTIONS.reduce(
  (accumulator, option) => {
    accumulator[option.value] = option.label;
    return accumulator;
  },
  {} as Record<LeadStage, string>,
);

export function formatLeadStage(stage: LeadStage): string {
  const label = LEAD_STAGE_LABEL_MAP[stage];
  if (typeof label === 'string' && label.length > 0) {
    return label;
  }
  return stage.replace(/_/g, ' ');
}
